import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { InvoiceModel } from '@data-layer/models/entry-summaries';
import { ValidationMessageModel } from '@data-layer/models/common';
import { DocumentCreateModel, DocumentModel } from '@data-layer/models/documents';
import {
  enumDocumentRelatedEntityType,
  enumDocumentRootEntityType,
  enumDocumentState,
  enumDocumentType,
} from '@data-layer/enums/documents';
import { Observable } from 'rxjs';
import { IEsDocumentStateUpdate } from '../../interfaces';

@Component({
  selector: 'es-invoice-attach-document',
  templateUrl: './es-invoice-attach-document.component.html',
  styleUrls: ['./es-invoice-attach-document.component.scss'],
})
export class EsInvoiceAttachDocumentComponent implements OnChanges {
  @Input() public entrySummaryId: number;
  @Input() public invoice: InvoiceModel;
  @Input() public attachedDocuments: DocumentModel[] = [];
  @Input() public isCanUploadDocuments: boolean = false;
  @Input() public isCanRemoveDocuments: boolean = false;
  @Input() public isShowEmptyLineItemDocuments: boolean = true;
  @Input() public index: number;
  @Input() public isCanLoadOther: boolean = false;
  @Input() public validationMessages: ValidationMessageModel[] = [];
  @Input() public upload: (document: DocumentCreateModel, file: File) => Observable<any>;
  @Input() public remove: (documentId: number) => Observable<any>;
  @Output() public addInvoiceOtherDocument: EventEmitter<DocumentModel> = new EventEmitter<DocumentModel>();
  @Output() public stateUpdate: EventEmitter<IEsDocumentStateUpdate> = new EventEmitter<IEsDocumentStateUpdate>();

  public invoiceDoc: DocumentModel;
  public invoiceOtherDocs: DocumentModel[] = [];
  public includesTypes: enumDocumentType[] = [enumDocumentType.PERMIT, enumDocumentType.TRADE_CERTIFICATE, enumDocumentType.UNKNOWN];
  public enumDocumentType: typeof enumDocumentType = enumDocumentType;
  public createDocumentTemplate: DocumentCreateModel;

  constructor() {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.attachedDocuments) {
      this.prepareInvoiceDocuments();
    }

    this.createDocumentTemplate = {
      relatedEntityType: enumDocumentRelatedEntityType.INVOICE,
      relatedEntityId: this.invoice.id,
      rootEntityType: enumDocumentRootEntityType.ENTRY_SUMMARY,
      rootEntityId: this.entrySummaryId,
      fileName: null,
      type: null,
    };
  }

  public onStateUpdate(data: IEsDocumentStateUpdate) {
    this.stateUpdate.emit(data);
  }

  private prepareInvoiceDocuments(): void {
    const invoiceDoc = this.findAttachedDocument() || {
      relatedEntityId: this.invoice.id,
      type: enumDocumentType.INVOICE,
      relatedEntityType: enumDocumentRelatedEntityType.INVOICE,
      rootEntityType: enumDocumentRootEntityType.ENTRY_SUMMARY,
      rootEntityId: this.entrySummaryId,
      fileName: null,
      url: null,
      createdDate: null,
      id: null,
      state: enumDocumentState.CREATED,
    };

    this.invoiceDoc = this.mergeDocument(this.invoiceDoc, invoiceDoc);

    this.invoiceOtherDocs = this.attachedDocuments.filter(
      (document) =>
        document.relatedEntityType === enumDocumentRelatedEntityType.INVOICE &&
        document.type !== enumDocumentType.FILE_PREVIEW &&
        document.relatedEntityId === this.invoice.id &&
        document.id !== this.invoiceDoc.id,
    );
  }

  private findAttachedDocument() {
    return this.attachedDocuments.find(
      (document) =>
        document.relatedEntityType === enumDocumentRelatedEntityType.INVOICE &&
        document.type === enumDocumentType.INVOICE &&
        document.relatedEntityId === this.invoice.id,
    );
  }

  private mergeDocument(existedDocument: DocumentModel, newDocument: DocumentModel): DocumentModel {
    if (!existedDocument) {
      return newDocument;
    }
    Object.assign(existedDocument, newDocument);
    return existedDocument;
  }
}
